import { Actions, IGetDisabledModules } from "../actions/DisabledModulesActions";
import { combineReducers } from "redux";

const getDisabledModulesReducer = (state = {}, action: any) => {
    switch (action.type) {
        case Actions.GET_DISABLED_MODULES_LOADING:
        case Actions.GET_DISABLED_MODULES_ERROR:
        case Actions.GET_DISABLED_MODULES_SUCCESS:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};

export interface IDisabledModulesData {
    disabledModules: IGetDisabledModules;
}

const disabledModulesData = combineReducers({
    disabledModules: getDisabledModulesReducer,

});

export default disabledModulesData;